import React from "react";
import UserIcon from "../icons/UserIcon";

const defaultImg =
  "https://www.kindpng.com/picc/m/252-2524695_dummy-profile-image-jpg-hd-png-download.png";

const UserCard = ({ user, isActive }) => {
  const fullImage =
    user?.identifications?.find((x) =>
      x?.identification_category?.name?.toLowerCase()?.includes("full image")
    )?.resource_path ?? defaultImg;

  return (
    <div
      style={user?.bgColor ? { backgroundColor: user?.bgColor } : {}}
      className={`flex flex-col min-w-[180px] bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-200 hover:scale-[1.02] p-5 gap-4 h-full w-full sm:w-auto items-start border-2
          ${isActive ? " border-blue-500 ring-2 ring-blue-200 " : " border-gray-200 "}
        `}
    >
      <div className="relative">
        {fullImage && fullImage !== defaultImg ? (
          <img
            src={fullImage}
            alt=""
            className="w-12 h-12 object-cover rounded-full border-2 border-gray-100"
          />
        ) : (
          <UserIcon 
            className="w-12 h-12" 
            bgColor="bg-gradient-to-br from-blue-100 to-indigo-100" 
            iconColor="text-blue-500" 
          />
        )}
        {isActive && (
          <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-blue-500 border-2 border-white rounded-full"></div>
        )}
      </div>

      <div className="flex flex-col gap-2 w-full">
        <p className="text-gray-900 font-semibold text-base">
          {user?.firstname} {user?.lastname}
        </p>
        <p
          title={user?.msisdn}
          className="text-gray-500 truncate w-full font-normal text-sm"
        >
          {user?.msisdn ?? user?.contact_number}
        </p>
      </div>
    </div>
  );
};

export default UserCard;
